module.exports = __webpack_public_path__ + "img/logo-gimmatek.05533667.png";